module.exports = __webpack_public_path__ + "static/img/queries-icon.4a144635.svg";